import { HistoricoPosicionesMedidorComponent } from './../../../popups/medidores/historico-posiciones-medidor/historico-posiciones-medidor.component';
import { MedidoresService } from './../../../../services/medidores.service';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material';
import { MapaService } from './../../../../services/mapa.service';
import { Medidores } from './../../../../../../_entities/medidores/Medidores';
import { DxDataGridComponent } from 'devextreme-angular';
import { Component, OnInit, ViewChild } from '@angular/core';
import { toUpper } from 'lodash';

@Component({
	selector: 'kt-medidor-modal',
	templateUrl: './medidor-modal.component.html',
	styleUrls: ['./medidor-modal.component.scss']
})
export class MedidorModalComponent implements OnInit {
	@ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent
	applyFilterTypes: any;
	currentFilter: any;
	showFilterRow: boolean;
	showHeaderFilter: boolean;
	usuario;
	medidores: Medidores[];
	public datosReporte = [];
	public isDisabled: boolean = true;
	//user = this.auth.getUser();

	constructor(private medidoresService: MedidoresService,
		private dialogRef: MatDialogRef<MedidorModalComponent>,
		//private auth: AuthService,
		private dialog: MatDialog,
		private mapaService: MapaService) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;
		this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
	}

	ngOnInit() {
		this.obtenerListaMedidores()
	}

	obtenerListaMedidores() {
		this.medidoresService.obtenerMedidores().subscribe(
			(medidores: Medidores[]) => {
				medidores.map(function (medidor) {
					if (medidor.estatus === 1) {
						medidor.estatus = ' Activo'
					} else {
						medidor.estatus = 'Inactivo'
					}
				});
				this.medidores = medidores;

				this.medidores.forEach(medidor => {
					this.datosReporte.push({
						'Descripción': medidor.descripcion,
						'IMEI': medidor.imei.toString(),
						'Estatus': medidor.estatus,
						'Modelo': medidor.modelo,
						'Cliente': medidor.cliente
					});
				});

				if (this.datosReporte.length > 0) {
					this.isDisabled = false;
				}

			}, (error) => {
				console.error(error);

			}
		)
	}

	reportePosiciones(data: any) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.width = "58%";
		dialogConfig.data = data;
		this.dialogRef.close();
		this.dialog.open(HistoricoPosicionesMedidorComponent, dialogConfig);
	}

	private static getOrderDay(rowData) {
		return (new Date(rowData.OrderDate)).getDay();
	}

	calculateFilterExpression(value, selectedFilterOperations, target) {
		let column = this as any;
		if (target === "headerFilter" && value === "weekends") {
			return [[MedidorModalComponent.getOrderDay, "=", 0], "or", [MedidorModalComponent.getOrderDay, "=", 6]];
		}
		return column.defaultCalculateFilterExpression.apply(this, arguments);
	}

	clearFilter() {
		this.dataGrid.instance.clearFilter();
	}

	orderHeaderFilter(data) {
		data.dataSource.postProcess = (results) => {
			results.push({
				text: "Weekends",
				value: "weekends"
			});
			return results;
		};
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

	ubicarPuntoHistorico(data) {
		this.mapaService.verMedidor(data);
		this.dialogRef.close();
	}

}
